<!-- eslint-disable -->
<template lang="pug">
div
    Spinner(
        :isVisible="loadingState.isLoading"
        :text="loadingState.message"
    )
    b-container(fluid)
        b-row(class="justify-content-center")
            b-col(cols="12" md="11")
                div(v-if="isLogged")
                    MainHeader(:sections="sections" :key="refreshKey")
                    Navbar
                .py-4.py-lg-4
                    router-view
                div(v-if="isLogged")
                    MenuBottom.d-flex.d-lg-none(:sections="sections")
</template>
<!-- eslint-enable  -->

<script>
import MainHeader from '@/components/Header/index.vue';
import Navbar from '@/components/Navbar/index.vue';
import MenuBottom from '@/components/MenuBottom/index.vue';
import FooterAgent from '@/components/FooterAgent/index.vue';
import moment from 'moment';

export default {
    components: {
        MainHeader,
        Navbar,
        MenuBottom,
        FooterAgent,
    },

    data() {
        return {
            refreshKey: 0
        };
    },

    mounted() {
        this.$root.$on('refreshLayout', () => {
            this.refreshKey++;
        });
    },

    methods: {
        updateRefreshKey() {
            this.refreshKey++;
        }
    },

    computed: {
        loadingState() {
            return this.$store.getters.getLoadingState;
        },
        /**
         * Comprueba si está logeado o no
         * @return {Boolean} Estado del login
         */
        isLogged() {
            return this.$route.meta.guest ? false : true;
        },

        sections() {
            const sections = [
                {
                    key: '/account/position',
                    title: 'Inicio',
                    icon: 'fa-home'
                },
                {
                    key: '/account/wallet',
                    title: 'Mi cartera',
                    icon: 'fa-euro-sign'
                },
                {
                    key: '/account/operations',
                    title: 'Operaciones',
                    icon: 'fa-expand-arrows'
                }
            ];
            const intervener = this.$store.getters.getIntervener;
            const isMinor = moment().diff(intervener.birthdate, 'years') < 18;
            if (['VALIDATED', 'RD_SENT', 'FINALIZED'].includes(intervener.status) && !isMinor) {
                sections.push({
                    key: '/operate',
                    title: 'Operar',
                    icon: 'fa-random'
                });
            }

            this.updateRefreshKey();
            return sections;
        }
    }
};

</script>